<template>
        <div id='mltb_upload'>
              <NavTop title='最美女神/男神投票-图片上传'/>
              <div class='content'>
                <img :src="sampleImg" class='sqimg'/>
                <div class='msg' v-if='isbm==1 && bminfo.status!=0'>
                  <span class='msgtxt' v-if='bminfo.status==1'>上传图片正在审核，请耐心等待结果</span>
                  <span class='msgtxt' v-if='bminfo.status==2'>恭喜您！您上传的图片已通过审核,您的投票号为:{{bminfo.votenum}}</span>
                  <span class='msgtxt' v-if='bminfo.status==3'>很抱歉！图片审核不通过，原因:{{bminfo.msg}}</span>
               </div>
              </div> 
              <div class="title-row">1、请按照上面的样例图，上传日常素颜肌肤照片2张</div>
              <div class="imgrow">
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img1==''?undefined:img1" :preview-image='false' image-fit="cover" name='img_1'/>
                  <span>食用前</span>
                 </div>
                 <div class="imgcol">
                  <van-uploader :after-read="afterRead" :upload-icon="img2==''?undefined:img2" :preview-image='false' image-fit="cover" name='img_2'/>
                  <span>食用后</span>
                 </div>
              </div>
              <div class="title-row">2、登记您的参赛姓名:</div>
              <div class='inputout'>
               <input placeholder="请输入您的姓名" class='inputclass' v-model='name'/>
              </div>
              <div class="btnrow">
                  <div class="sumitbtn" @click="doBm">
                     确认上传图片
                  </div>
              </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { NoticeBar, Uploader} from 'vant'
import {put} from '@/api'
export default {
  data(){
      return{
         sampleImg:'',
         img1:'',
         img2:'',
         name:'',
         isbm:0,
         bminfo:{},
         processing:false
      }
  },  
  name: 'sporder2bm_end',
  created(){
     this.getList()
  },
  methods:{
     getList(){
        this.$post("/mltb/getWevoteInfo").then((data)=>{
               if(data.result.success){
                  this.isbm=parseInt(data.result.info.isbm)
                  if(this.isbm){
                     this.bminfo=data.result.info.bminfo
                     this.img1=this.bminfo.img1
                     this.img2=this.bminfo.img2
                     this.name=this.bminfo.name
                  }
                  this.sampleImg=data.result.info.sampleImg
               }else{
                 this.$toast(data.result.info)
                 setTimeout(()=>{this.$go("/my")},1000)
               }
           }) 
     },
     doBm(){
        if(this.processing){
           this.$toast("请等待提交完成");return false;
        }
        if(this.img1==''|| this.img1==undefined){
            this.$toast("请上传日常素颜肌肤照片1");return false;
        }
        if(this.img2==''|| this.img2==undefined){
            this.$toast("请上传日常素颜肌肤照片2");return false;
        }
        if(this.name==''||this.name==undefined){
            this.$toast("请输入您的姓名");return false;
        }
        this.bminfo["img1"]=this.img1
        this.bminfo["img2"]=this.img2
        this.bminfo["name"]=this.name
 
        this.processing=true
        this.$post("/mltb/saveWevoteInfo",{bminfo:this.bminfo}).then((data)=>{
           this.processing=false
           if(data.result.success){
              this.$toast(data.result.info)
              this.getList()
           }else{
              this.$toast(data.result.info)
           }
        })
     },
     afterRead(file,info) { 
      let name=info.name   
      let tag=name.split("_")
      let index=tag[1]
      const uploadImgFile=file.content
      this.$post("/uploader/headImgBase64",{type:'headimg',image:uploadImgFile}).then((data)=>{
           if(data.result.success){
               this['img'+index]=data.result.info.url 
           }
      })
    }
  },
  components:{
      NavTop,
      [NoticeBar.name]:NoticeBar,
      [Uploader.name]:Uploader
  }
}
</script>
<style scoped>
#mltb_upload{background-color:#fff;min-height: 100vh;padding-bottom: 0.5rem;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;width:100%;position: relative;}
.sqimg{width:100%;display: block;}
::v-deep .fixcon{margin-bottom: 0!important;}
.title-row{font-size:0.3rem;width: 100%;text-align: left;font-weight: 600;padding: 0.3rem;}
.imgrow{display: flex;flex-flow: row;width: 100%;padding: 0 0.3rem;}
.imgcol{width:25%;display: flex;flex-flow: column nowrap;justify-content: center;font-size:0.25rem;}

.btnrow{display: flex;flex-flow: row;width: 100%;justify-content: center;align-items: center;padding: 0 0.3rem;margin-top: 0.25rem;}
.sumitbtn{width:100%;border-radius: 0.2rem;background-color: #ee0a24;color:#fff;font-size:0.38rem;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}

::v-deep .van-uploader{display:flex ;justify-content: center;}
::v-deep .van-uploader__upload-icon{font-size:80px;}
::v-deep .van-uploader__upload{margin: 0;background-color: #fff;}

.inputout{margin-top:10px;width:100%;}
.inputclass{border: 1px solid #ccc;padding: 0 0.3rem;font-size:0.3rem;width:100%;height:1rem;line-height: 1rem;}
.msg{position: absolute;top:0;left:0;width:100%;height:1rem;display: flex;flex-flow: row nowrap;align-items: center;background-color: #fef0f0;opacity: .7;padding-left: 0.125rem;}
.msgtxt{font-size:0.32rem;color:#f56c6c;font-weight: 600;}
</style>


